import List from './default'
import Grouped from './grouped'

const TransferList = List
TransferList.Grouped = Grouped

export default TransferList
